import { WisdomSavedChatToolbar } from '@modules/oracle/components/WisdomChatToolbar/WisdomSavedChatToolbar';
import { WisdomUnSavedChatToolbar } from '@modules/oracle/components/WisdomChatToolbar/WisdomUnSavedChatToolbar';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';

export function WisdomChatToolbar() {
  const chat = useOracleSearchStore(({ data }) => data.chat);

  if (chat) {
    return <WisdomSavedChatToolbar />;
  }

  return <WisdomUnSavedChatToolbar />;
}
